import React from 'react';
import { Layout } from '@arco-design/web-react';
import { FooterProps } from '@arco-design/web-react/es/Layout/interface';
import cs from 'classnames';
import styles from './style/index.module.less';

function Footer(props: FooterProps = {}) {
  const { className, ...restProps } = props;
  return (
    <div></div>
    // <Layout.Footer className={cs(styles.footer, className)} {...restProps}>
    //   北京理工智慧教育
    // </Layout.Footer>
  );
}

export default Footer;
